import * as React from 'react';

import CustomTemplate56 from './CustomTemplate56';

export const customTemplate56 = () => <CustomTemplate56 />;

export default {
    title: 'Illustration/CustomTemplate56',
    component: CustomTemplate56,
    parameters: {
        notes: "`import CustomTemplate56 from 'box-ui-elements/es/illustration/CustomTemplate56';`",
    },
};
